import { useEffect, useState } from 'react';
import { useApiHub } from '../ApiHubContext';
import { getFetchJson } from '../fetchUtils';
export const fetchResetPassword = async (urlWithTenant, originHubName, username, publicKey) => {
    var cookies = document.cookie.split('; ');
    for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split('.');
        while (d.length > 0) {
            var cookieBase = encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
                '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
                d.join('.') +
                ' ;path=';
            // eslint-disable-next-line no-restricted-globals
            var p = location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
                document.cookie = cookieBase + p.join('/');
                p.pop();
            }
            d.shift();
        }
    }
    const fetchJson = getFetchJson(originHubName);
    const headers = new Headers({
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'text/plain, */*; q=0.01',
    });
    if (publicKey) {
        headers.set('Public-Key', publicKey);
    }
    const { json } = await fetchJson(`${urlWithTenant}/reset-my-password`, {
        credentials: 'include',
        method: 'PUT',
        headers: headers,
        body: JSON.stringify({ userName: username }),
    });
    return await json;
};
export const useResetPassword = () => {
    const { urlWithTenant, originHubName } = useApiHub();
    const [username, setUsername] = useState('');
    const [fetched, setFetched] = useState(false);
    useEffect(() => {
        if (!fetched && username !== '') {
            fetchResetPassword(urlWithTenant, originHubName, username).then(() => {
                setFetched(true);
            });
        }
    }, [urlWithTenant, fetched, username, originHubName]);
    return [username, setUsername];
};
//# sourceMappingURL=useResetPassword.js.map